<div class="main-container" *ngIf="_show">
  <span class="close clickable" style="color: white;" (click)="close()">x</span>
  <div class="row g-0 justify-content-center align-items-center mt-4">
    <img src="assets/img/whatsapp.png" class="whatsapp-image" alt="contacto_whatsapp">
  </div>
  <div class="row g-0 align-items-center mt-3" style="color: #f2c63d;">
    <p>
      Escanee el código QR desde su móvil para contactar con el radiólogo mediante un mensaje de texto o una llamada a
      través de WhatsApp.
    </p>
    <p>
      Si ya tiene WhatsApp instalado en este dispositivo, pulse el botón "Abrir en WhatsApp"
    </p>
  </div>
  <button class="btn btn-primary open_on_app_button" (click)="openWhatsapp()">Abrir en WhatsApp</button>
</div>